import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import internet from '@devices/settings/device_settings/internet.js';
import actions from '@devices/settings/device_settings/actions.js';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'Shelly2LED',
	friendly_name: '2 Led',
	family: 'light',
	isPM: false,
	modes: {
		white: {
			channels: 2,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			color: false,
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer,
				schedule,
				internet,
				actions,
				roller_app_setting_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'device_type', component: 'device_type' },
						{ title: 'button_type', component: 'button_type' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'transition_time', component: 'transition_time' },
						{ title: 'dc_supply_voltage', component: 'dc_supply_voltage' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
